import { useCallback, useState } from 'react';

import { useLanguage } from '../../contexts/language';

import { ReviewAnswer } from '../review-answer';

import styles from './style.module.css';

// Every answer of a submitted test, each opening to its options and the
// clinician's note, with Expand all and Collapse all. Which answers are open
// is this list's own state.
export function ReviewAnswers({ attemptId, answers, options, patientName }) {
  const { text } = useLanguage();
  const [ opened, setOpened ] = useState({});

  const toggle = useCallback(function(position) {
    setOpened(function(current) {
      return { ...current, [ position ]: current[ position ] !== true };
    });
  }, []);

  const everyOpen = answers.every(function({ position }) {
    return opened[ position ] === true;
  });

  const toggleAll = useCallback(function() {
    setOpened(function(current) {
      const all = answers.every(function({ position }) {
        return current[ position ] === true;
      });

      if (all === true) {
        return {};
      }

      return Object.fromEntries(answers.map(function({ position }) {
        return [ position, true ];
      }));
    });
  }, [ answers ]);

  let allLabel = text.expandAll;

  if (everyOpen === true) {
    allLabel = text.collapseAll;
  }

  const rows = answers.map(function(answer) {
    return (
      <ReviewAnswer
        key={ answer.position }
        attemptId={ attemptId }
        answer={ answer }
        options={ options }
        patientName={ patientName }
        open={ opened[ answer.position ] === true }
        onToggle={ toggle }
      />
    );
  });

  return (
    <section className={ styles.answers } aria-label={ text.answers }>
      <div className={ styles.top }>
        <span className={ styles.hint }>{ text.answersHint.replace('{name}', patientName) }</span>

        <button className={ styles.all } type='button' onClick={ toggleAll }>{ allLabel }</button>
      </div>

      { rows }
    </section>
  );
}
